export default __webpack_public_path__ + "static/media/telly-march.98a8d92d.svg";